import { ManualOpenItemProcessingPrePostReview } from "../ManualOpenItemProcessingPrePostReview";
import { Layout, Step, Stepper } from "@mcleod/components";

export abstract class AutogenLayoutManualOpenItemProcessingStepper extends Layout {
    layoutManualOpenItemProcessingPrePostReview: ManualOpenItemProcessingPrePostReview;
    stepEditList: Step;
    stepPostingReports: Step;
    stepPrePostReview: Step;
    stepperManualOpenItemProcessing: Stepper;
}
